import ApiCore from "../utilities/core";

const url = 'sfa-dashboard';
const plural = 'sfa-dashboard';
const single = 'sfa-dashboard';

// Custom SFA Dashboard API with specific methods
class SfaDashboardApi extends ApiCore {
    constructor() {
        super({
            getAll: true,
            url: url,
            plural: plural,
            single: single,
            requireToken: true
        });
    }

    // Get dashboard summary
    getSummary() {
        return this.getAll('summary');
    }

    // Get status counts
    getStatusCounts() {
        return this.getAll('status-counts');
    }

    // Get full dashboard with filters
    getDashboard(filters = {}) {
        const queryParams = new URLSearchParams();
        
        Object.keys(filters).forEach(key => {
            if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '') {
                queryParams.append(key, filters[key]);
            }
        });

        const queryString = queryParams.toString();
        return this.getAll(queryString);
    }
}

export default new SfaDashboardApi(); 